import { ItemStatus } from "@focus/interfaces/lib/common/itemFetchStatus";
import { saveAs } from "file-saver/FileSaver";
import * as actions from "./actions";
import { type Actions } from "./actions";
import { actionTypes } from "./actionTypes";
import { type DownloadConfig } from "./interfaces";
import {
  downloadOrbit,
  downloadZipOrbit,
  showUploadErrorPopup,
  showUploadOkPopup,
  uploadOrbit,
} from "./middleware";
import { createNotificationsEpicForAction } from "./notification";

export const uploadOrbitUrlBuilder = (operator) => {
  return `/api/v1/inputs/${operator}/orbits`;
};

export const downloadConjunctionFilesUrl = ({ id }: DownloadConfig) =>
  `/api/v1/conjunctions/${id}/files`;

export const downloadOrbitFilesUrl = ({ id }: DownloadConfig) =>
  `/api/v1/orbits/${id}/files`;

export interface UploadedOrbitEntry {
  filename: string;
  size: number;
  operator: string;
  status: ItemStatus;
  errorMessage?: unknown;
}

export type UploadedOrbitsState = Record<string, UploadedOrbitEntry>;

const initialState: UploadedOrbitsState = {};

export const uploadOrbitSelectors = {
  getReadyUploadsStatusKey: (state: UploadedOrbitsState = initialState) =>
    Object.entries(state)
      .filter(([, upload]) => upload.status === ItemStatus.READY)
      .map(([id]) => id)
      .join("|"),
};

function reducer(state = initialState, actionFile: Actions) {
  const action: any = actionFile;
  const fileEntries = action?.payload?.files ? action?.payload?.files : [];

  const updatedState: UploadedOrbitsState = {};
  switch (action.type) {
    case actionTypes.UPLOAD_ERROR:
      fileEntries.forEach((fe) => {
        updatedState[fe.id] = {
          filename: fe.file.name,
          size: fe.size,
          operator: action.payload.operator,
          status: ItemStatus.ERROR,
          errorMessage: action.payload,
        };
      });
      return { ...state, ...updatedState };
    case actionTypes.UPLOAD_PENDING:
      fileEntries.forEach((fe) => {
        updatedState[fe.id] = {
          filename: fe.file.name,
          size: fe.size,
          operator: action.payload.operator,
          status: ItemStatus.PENDING,
          errorMessage: "",
        };
      });
      return { ...state, ...updatedState };
    case actionTypes.UPLOAD_FINISH:
      fileEntries.forEach((fe) => {
        updatedState[fe.id] = {
          filename: fe.file.name,
          size: fe.size,
          operator: action.payload.operator,
          status: ItemStatus.READY,
          errorMessage: "",
        };
      });
      return { ...state, ...updatedState };
    case actionTypes.UPLOAD_DELETE:
      if (action.payload?.id) {
        const remainingUploads = { ...state };
        delete remainingUploads[action.payload.id];
        return remainingUploads;
      }
      return initialState;
    default:
      return state;
  }
}

export const createUploadOrbit = () => {
  const middleware = [
    uploadOrbit(uploadOrbitUrlBuilder),
    downloadZipOrbit(downloadConjunctionFilesUrl, saveAs),
    downloadOrbit(downloadOrbitFilesUrl, saveAs),
    createNotificationsEpicForAction(),
    showUploadOkPopup(),
    showUploadErrorPopup(),
  ];
  const selectors = uploadOrbitSelectors;
  return { actions, reducer, middleware, selectors };
};
